import { forwardRef } from "react";
import { cn } from "../../lib/cn.js";

const Spinner = forwardRef(
  (
    {
      className,
      size = "md",
      ...props
    },
    ref
  ) => {
    const sizeClasses = {
      sm: "h-4 w-4 border-2",
      md: "h-6 w-6 border-2",
      lg: "h-8 w-8 border-3",
    };
    
    return (
      <div
        ref={ref}
        className={cn(
          "inline-block animate-spin rounded-full border-current border-t-transparent",
          sizeClasses[size] || sizeClasses.md,
          className
        )}
        {...props}
      />
    );
  }
);

Spinner.displayName = "Spinner";

export default Spinner;